module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-format-bf71a7caeac521df38629ae8c3d19bc0.png";